module.exports = __webpack_public_path__ + "static/media/santacatarina.50189234.png";